import { Endpoint } from '@business/api/endpoint';
import { DiscountTypeId, DiscountTypeRequest, DiscountTypeResponse } from '@business/entities/tm';

export function fetchDiscountTypes() {
  return Endpoint.get<DiscountTypeResponse[]>(`@gc/discount-types`);
}

export function createDiscountType(data: DiscountTypeRequest) {
  return Endpoint.post<DiscountTypeResponse[]>(`@gc/discount-types`, { data });
}

export function updateDiscountType(id: DiscountTypeId, data: DiscountTypeRequest) {
  return Endpoint.patch<DiscountTypeResponse[]>(`@gc/discount-types/${id}`, { data });
}

export function deleteDiscountType(id: DiscountTypeId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/discount-types/${id}`);
}

export function sortDiscountTypes(ids: DiscountTypeId[]) {
  return Endpoint.post<DiscountTypeResponse[]>(`@gc/discount-types/sort`, { data: { ids } });
}
